import React, {useEffect, useRef, useState} from "react";
import {
    Button,
    Col,
    ControlLabel,
    FormControl,
    FormGroup,
    Glyphicon,
    Panel,
    Row
} from "react-bootstrap";
import DeleteConfirmOverlay from "../../../../UI/DeleteConfirmOverlay";
import {quizPartnerCreate, quizPartnerUpdate} from "../../../../../../api/cp";
import PanelBody from "react-bootstrap/lib/PanelBody";

const PartnerRow = ({partner, quiz, onDelete}) => {
    const [id, setId] = useState(null);
    const [properties, setProperties] = useState({});
    const logoUploadRef = useRef(null);

    useEffect(() => {
        resetPartner(partner);
    }, [partner]);

    const resetPartner = (partner) => {
        setId(partner?.id || null);
        setProperties({
            titleRu: partner?.titleRu || '',
            titleEn: partner?.titleEn || '',
            logoBackgroundColor: partner?.logoBackgroundColor || '',
            logoUrl: partner?.logoUrl || '',
            logoHref: partner?.logoHref || '',
        })
    }

    const getProperty = (name) => {
        return properties[name] || '';
    }

    const setProperty = (name, value) => {
        setProperties({...properties, [name]: value});
    }

    const savePartner = async (data) => {
        try {
            let partner;
            if (id) {
                partner = await quizPartnerUpdate(id, data);
            } else {
                partner = await quizPartnerCreate(quiz.id, data);
            }
            resetPartner(partner);
        } catch (e) {
            console.error(e);
        }
    }

    const saveProperty = async (name, value) => {
        await savePartner({[name]: value});
    }

    const savePropertyFile = async (name, file) => {
        const data = new FormData();
        data.append(name, file);
        await savePartner(data);
    }

    return (
        <Panel>
            <PanelBody>
                <Row>
                    <Col xs={3}>
                        <FormGroup>
                            <ControlLabel>Логотип</ControlLabel>
                            <div>
                                <img src={getProperty('logoUrl')} style={{maxWidth: 80, maxHeight: 36}} alt="" />
                                {' '}
                                <Button onClick={() => logoUploadRef.current?.click()}><Glyphicon glyph="folder-open" /></Button>
                                {' '}
                                {getProperty('logoUrl') && <Button onClick={() => saveProperty('logo', 'delete')}><Glyphicon glyph="trash" /></Button>}
                                <FormControl
                                    type="file"
                                    onChange={(e) => savePropertyFile('logo', e.target.files[0] || null)}
                                    inputRef={(ref) => logoUploadRef.current = ref}
                                    style={{display: 'none'}}
                                />
                            </div>
                        </FormGroup>
                    </Col>
                    <Col xs={8}>
                        <FormGroup>
                            <ControlLabel>Ссылка</ControlLabel>
                            <FormControl
                                type="text"
                                value={getProperty('logoHref')}
                                onChange={(e) => setProperty('logoHref', e.target.value)}
                                onBlur={() => saveProperty('logoHref', getProperty('logoHref'))}
                            />
                        </FormGroup>
                    </Col>
                    <Col xs={1}>
                        <FormGroup>
                            <ControlLabel>&nbsp;</ControlLabel>
                            <div>
                                <DeleteConfirmOverlay title="Удалить партнёра?" onConfirm={onDelete}>
                                    <Button bsSize="small" bsStyle="danger"><Glyphicon glyph="trash" /></Button>
                                </DeleteConfirmOverlay>
                            </div>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col xs={6}>
                        <ControlLabel>Название [Ru]</ControlLabel>
                        <FormControl
                            type="text"
                            value={getProperty('titleRu')}
                            onChange={(e) => setProperty('titleRu', e.target.value)}
                            onBlur={() => saveProperty('titleRu', getProperty('titleRu'))}
                        />
                    </Col>
                    <Col xs={6}>
                        <ControlLabel>Название [En]</ControlLabel>
                        <FormControl
                            type="text"
                            value={getProperty('titleEn')}
                            onChange={(e) => setProperty('titleEn', e.target.value)}
                            onBlur={() => saveProperty('titleEn', getProperty('titleEn'))}
                        />
                    </Col>
                </Row>
            </PanelBody>
        </Panel>
    );
}

export default ({partners, quiz, onCreate, onDelete}) => {
    return (
        <>
            {partners.map((partner) => (
                <PartnerRow key={partner.id} partner={partner} quiz={quiz} onDelete={() => onDelete(partner.id)} />
            ))}
            <Button onClick={onCreate} bsStyle="success">Добавить партнёра</Button>
        </>
    );
}
